<template>
  <nav class="col-sm-12 mb-2">
    <div class="card nav">
      <div class="card-body">
        <a v-if="mode ===''"
           class="btn btn-secondary btn-lg me-2"
           @click="setMode('new'), resetNewContent()">Nieuw Bestand
          <font-awesome-icon icon="file" />
        </a>
        <a v-if="mode ===''"
           class="btn btn-secondary btn-lg me-2"
           @click="setMode('existing')">Importeer Bestand
          <font-awesome-icon icon="folder-open" />
        </a>
        <a v-if="mode !==''"
           @click="setMode('')">
          <font-awesome-icon icon="angle-left" /> Terug
        </a>
      </div>
    </div>
  </nav>
</template>

<script>

const getInitNewContent = () => {
  return {
    school: {
      schooljaar: "",
      brincode: "",
      dependancecode: "",
      aanmaakdatum: "",
      xsdversie: 2.3
    },
    groepen: { groep: [], samengestelde_groep: [] },
    leerlingen: { leerling: [] },
    leerkrachten: { leerkracht: [] },

  }
}

export default {
  name: 'navigation',
  props: {
    mode: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      newContent: getInitNewContent()
    }
  },
  methods: {
    setMode(v) {
      if (v === 'new') {
        this.$emit('setMode', v)
        this.$emit('setContent', this.newContent)
      } else {
        this.$emit('setMode', v)
      }
    },
    resetNewContent() {
      this.newContent = getInitNewContent()
    }
  }
}
</script>